/**
 *
 * Zipcode searcher
 *
 */
jQuery(document).ready(function () {
  jQuery(".btn-zipcode").click(function () {
    var zip = jQuery("#zipcode").val();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "formSubmission",
      formID: "zipCode",
      formValue: zip,
    });

    // Here we check if the zip is empty, in that case, we just apply the filters.
    if (zip == "") {
      jQuery(".tease-tuotteet").each(function () {
        var teaseElement = jQuery(this);
        teaseElement.show();
        applyFilters(teaseElement);
      });
      return;
    }

    // solve zip code geoloc
    jQuery.getJSON(
      "https://maps.google.com/maps/api/geocode/json?key=AIzaSyDVkgtCKxbIBuYwhbVswaf8yjSSja0gXyQ&components=country:FI&address=" +
        zip,
      (googledata) => {
        if (googledata.status == "OK") {
          // console.debug( googledata.results[0].geometry.location )
          // check each if in range
          jQuery(".tease-tuotteet").each(function () {
            var locArray = jQuery(this).data("geolocation").split(",");
            var loc = { lat: locArray[0], lng: locArray[1] };
            var range = jQuery(this).data("range");
            var teaseElement = jQuery(this);
            teaseElement.show();

            if (
              isInRange(googledata.results[0].geometry.location, loc, range)
            ) {
              if (teaseElement.hasClass("postNumberFilterable")) {
                console.log("Postnumber filled");
                jQuery(this).show();
                applyFilters(teaseElement);
              } else {
                applyFilters(teaseElement);
              }
              /*
                if (document.getElementById("luomucheck").checked === true) {
                  if (teaseElement.hasClass('luomu')) {
                    jQuery(this).hide();
                  }
                }*/
            } else {
              jQuery(this).hide();
            }
          });
        } else {
          console.debug("No location.");
        }
      }
    );
    //}
  });
  if (document.querySelector("#zipcode"))
    document.querySelector("#zipcode").addEventListener("input", (e) => {
      if (e.target.value.length > 0) {
        document.querySelector("#clear-postcode").classList.remove("d-none");
      } else {
        document.querySelector("#clear-postcode").classList.add("d-none");
      }
    });
  if (document.querySelector("#clear-postcode"))
    document.querySelector("#clear-postcode").addEventListener("click", (e) => {
      e.target.classList.add("d-none");
      document.querySelector("#zipcode").value = "";
      jQuery(".tease-tuotteet").each(function () {
        applyFilters(jQuery(this));
      });
    });
});

function isInRange(locA, locB, distance) {
  if (distance == "") {
    return false;
  }

  var radlat1 = (Math.PI * locA.lat) / 180;
  var radlat2 = (Math.PI * locB.lat) / 180;
  var theta = locA.lng - locB.lng;
  var radtheta = (Math.PI * theta) / 180;
  var dist =
    Math.sin(radlat1) * Math.sin(radlat2) +
    Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  if (dist > 1) {
    dist = 1;
  }
  dist = Math.acos(dist);
  dist = (dist * 180) / Math.PI;
  dist = dist * 60 * 1.1515;
  dist = dist * 1.609344; // to KM

  // console.debug( dist, distance )

  if (dist <= distance) {
    return true;
  }
  return false;
}

// Helper function to hide/show based on filters
function applyFilters(teaseElement) {
  var eco = document.getElementById("luomucheck").checked === true;
  var winter = document.getElementById("talvicheck").checked === true;
  console.log(eco, winter);
  if (eco && winter) {
    if (teaseElement.hasClass("luomu") && teaseElement.hasClass("talvi")) {
      jQuery(teaseElement).show();
    } else {
      jQuery(teaseElement).hide();
    }
  } else if (eco) {
    if (teaseElement.hasClass("luomu")) {
      jQuery(teaseElement).show();
    } else {
      jQuery(teaseElement).hide();
    }
  } else if (winter) {
    if (teaseElement.hasClass("talvi")) {
      jQuery(teaseElement).show();
    } else {
      jQuery(teaseElement).hide();
    }
  } else {
    jQuery(teaseElement).show();
  }
}
